import { useMutation } from "@/api/utils/useQuery"
import { ApiError, MutationResult } from "@/api/utils/types"
import { ITenancyCreate } from "@/mutators/tenancy/TenancyMutator.types"
import {
  getTariffInfoMoveOut,
  getForwardingAddressMoveOut,
  getDirectDebitInfoMoveOut,
  getForwardingContactMoveOut,
  getTenancyContactsMoveOut,
} from "@/mutators/tenancy/TenancyMutator.helpers"
import dayjs from "dayjs"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { useCurrentAccountStore } from "@/stores/currentAccount"
import { AuthService } from "@/services/AuthService"
import {
  ChangeOfTenancyType,
  ChangeOfTenancyRequestDto,
  ChangeOfTenancyResponseDto,
} from "@/api/backofficeRest/generated/model"

export interface ITenancyMutator {
  createChangeOfTenancy(
    onSuccessFn: (response: ChangeOfTenancyResponseDto) => unknown,
    onErrorFn: (error: ApiError) => unknown,
  ): MutationResult<ITenancyCreate, ChangeOfTenancyResponseDto>
}

class TenancyMutatorClass implements ITenancyMutator {
  createChangeOfTenancy(
    onSuccessFn,
    onErrorFn,
  ): MutationResult<ITenancyCreate, ChangeOfTenancyResponseDto> {
    return useMutation({
      ...BackofficeRestMutations.tenancy.create(),
      serializerFn: (data: ITenancyCreate): ChangeOfTenancyRequestDto => {
        let serializedData: ChangeOfTenancyRequestDto = {
          account_id: data.isMovingIn
            ? undefined
            : useCurrentAccountStore().coreId.data?.toString(),
          account_number: useCurrentAccountStore().accountNumber.toString(),
          agent_email: AuthService.getCurrentUser().username.toString(),
          address_postcode: data.account.supplyAddress?.postcode ?? "",
          balance_transfer: false,
          contacts: getTenancyContactsMoveOut(data),
          date: dayjs(data.dateOfResponsibility).format("YYYY-MM-DD"),
          occupier_details_notes:
            data?.nextResponsiblePartyDetails || data.userNote,
          type: data.isMovingIn
            ? ChangeOfTenancyType.ChangeOfTenancyMoveIn
            : ChangeOfTenancyType.ChangeOfTenancyMoveOut,
        }

        serializedData = getForwardingContactMoveOut(data, serializedData)
        serializedData = getDirectDebitInfoMoveOut(data, serializedData)
        serializedData = getForwardingAddressMoveOut(data, serializedData)
        serializedData = getTariffInfoMoveOut(data, serializedData)
        return serializedData
      },
      onSuccessFn,
      onErrorFn,
    })
  }
}

export const TenancyMutator = new TenancyMutatorClass()
